import React, { PropTypes } from 'react';

const RemoveFile = props => {
  const {
    removeFile,
    top,
    left,
  } = props;

  return (
    <div style={{
      cursor: 'pointer',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      opacity: '0.7',
      fontSize: '14px',
      backgroundColor: '#FFFFFF',
      borderRadius: '50%',
      height: '20px',
      width: '20px',
      position: 'absolute',
      color: 'rgb(255, 64, 129)',
      border: '1px solid #bdbdbd',
      top: top || '77%',
      left: left || '80%',
    }}
      className="file-preview-close"
      onTouchTap={removeFile}
    >
      <span style={{ marginTop: '-1px' }}>X</span>
    </div>
  );
};

RemoveFile.propTypes = {
  removeFile: PropTypes.func,
  top: PropTypes.string,
  left: PropTypes.string,
};

export default RemoveFile;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/removeFile.jsx